export default "__VITE_ASSET__C8bu9UI8__"